export default {
  AWAITING_ASSIGNMENT: 1,
  IN_PROGRESS: 2,
  AWAITING_APPROVAL: 3,
  APPROVED: 4,
  COMPLETE: 5,
};
